import { configureCatalogStore } from '@state';
import { initQuerySync } from '@utils/search';
import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import AnimatedProvider from '@moncler/components/routerTransitions/AnimatedProvider';
import AnimatedRoute from '@moncler/components/routerTransitions/AnimatedRoute';
const Pdp = React.lazy(() => import('@moncler/components/product/ProductPage'));
const Plp = React.lazy(() => import('@moncler/components/listing/PlpPage'));
const store = configureCatalogStore();
initQuerySync(store);
const localeURLMapping = (documentLocale) => {
    const languageMapping = {
        'zh-hant-hk': 'zht-hk',
        'zh-hant-sg': 'zht-sg',
        'zh-hans-hk': 'zh-hk',
        'zh-hans-sg': 'zh-sg',
    };
    return languageMapping[documentLocale] || documentLocale;
};
const Catalog = (props) => {
    var _a;
    const locale = localeURLMapping(((_a = document.documentElement.lang) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || 'en');
    const prefix = location.pathname.substr(0, location.pathname.indexOf(locale));
    const basePath = `${prefix}${locale}`;
    return (React.createElement(Provider, { store: store },
        React.createElement(BrowserRouter, { basename: basePath },
            React.createElement(AnimatedProvider, null,
                React.createElement(AnimatedRoute, { path: "/:path(.*)-:pid.html", key: "pdp" },
                    React.createElement(Suspense, { fallback: React.createElement("div", null) },
                        React.createElement(Pdp, Object.assign({}, props)))),
                React.createElement(AnimatedRoute, { path: "/:slug([\\w\\d\\/-]*)", key: "plp" },
                    React.createElement(Suspense, { fallback: React.createElement("div", null) },
                        React.createElement(Plp, Object.assign({}, props))))))));
};
export default Catalog;
